export default {
	title: 'Interessi',
	url: 'interessi',
	no_description: 'Nessun obiettivo definito',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtri vista'
		},
		general: {
			title: 'Generale'
		},
		export: {
			title: 'Esporta'
		},
		comments: {
			title: 'Cronologia'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_stake: 'Modifica interesse',
		create_stake: 'Crea un nuovo interesse'
	},
	onboarding: {
		title: 'Revisione degli interessi',
		description:
			"L'IA ha identificato gli interessi strutturali del tuo tema. Verifica che rappresentino davvero ciò che potresti perdere o guadagnare se non si interviene. Aggiusta, rimuovi o completa se necessario."
	}
};
